import { render, staticRenderFns } from "./AdminComposeMessage.vue?vue&type=template&id=40ac7244&scoped=true"
import script from "./AdminComposeMessage.vue?vue&type=script&lang=js"
export * from "./AdminComposeMessage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/admin_message_center.css?vue&type=style&index=0&id=40ac7244&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac7244",
  null
  
)

export default component.exports